<section class="demo-hero section__bg-gradient-parent">
  <div class="demo-hero__background" aria-hidden="true">
    <img
      class="demo-hero__bg-image"
      fill
      priority
      ngSrc="/assets/demo/hero-bg-sm.png"
      alt="demo-hero background"
    />
  </div>

  <div class="demo-hero__inner container">
    <div class="demo-hero__content">
      <div class="demo-hero__text">
        <h1 class="demo-hero__title heading">EVRN is optimized for desktop</h1>
        <p class="demo-hero__subtitle subheading">
          The interactive 3D experience is currently available on desktop only. Open this page on a
          desktop computer to explore EVRN, or visit our YouTube channel to watch demos.
        </p>
      </div>

      <div class="demo-hero__cta">
        <app-button fullWidth href="https://www.youtube.com/@evrn_world"
          >Watch demos on YouTube</app-button
        >
      </div>
    </div>
  </div>
</section>
